import React from "react";
import { Handle, Position } from "reactflow";

import NodeHeader from "./NodeHeader/NodeHeader";
import { useFlowNodes } from "../../../context";

import "./EntryIntentNode.scss";

const EntryIntentNode = ({ id }) => {
  const { t, setNodes, setEdges, ...res } = useFlowNodes();
  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="entry-node-container">
        <NodeHeader
          title={t("common:intents.flow_chat.entry.title")}
          setNodes={setNodes}
          setEdges={setEdges}
          nodeId={id}
          {...res}
        />
      </div>
    </>
  );
};

export default EntryIntentNode;
